import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import Icon from "%/dynamic-components/render-engine/options/icon-options/icon";
import IconVariant from "%/dynamic-components/render-engine/options/icon-options/icon-variant";
import IconSize from "%/dynamic-components/render-engine/options/icon-options/icon-size";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import IconColor from "%/dynamic-components/render-engine/options/icon-options/icon-color";

export default class IconOptions extends BaseOptionsBundle {

  optionTitle = "Icon";
  static optionClassName = "i-dynamic-icon";
  inspectorToolGroup = "icon";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.ICON_TOOL_SET,
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new Icon(undefined, hideFromInspector["icon"] ?? false),
      IconVariant,
      IconSize,
      IconColor,
    ]);
  }
}
